import { React, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Agreements from "./Pages/HomePage/Agreements/Agreements";
import Treatments from "./Pages/HomePage/Treatments/Treatments";
import Cities from "./Pages/HomePage/Cities/Cities";
import Hospital from "./Pages/HomePage/Hospital/Hospital";
import Doctors from "./Pages/HomePage/Doctors/Doctors";
import DashBoard from "./Pages/HomePage/DashBoard/DashBoard";
import MenuBar from "./Components/SideMenuBar/MenuBar";
import { Grid } from "@mui/material";
import HospitalAddPage from "./Pages/HomePage/Hospital/HospitalAddPage";
import AddNewDoctor from "./Pages/HomePage/Doctors/AddNewDoctor/AddNewDoctor";
import LoginPage from "./Pages/LoginPage/LoginPage";
import { isEmpty } from "./Utils/helper";
import "./App.css";
import InsuranceHome from "./Pages/HomePage/Insurance/InsuranceHome";
import MySpace from "./Pages/HomePage/MySpace/MySpace";
import ApprovalsPending from "./Pages/HomePage/ApprovalsPending/ApprovalsPending";
import Details from "./Pages/HomePage/Details/Details";

function App() {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    const login = localStorage.getItem("isLogin");
    if (login === "true") {
      setIsLogin(true);
    } else if (login === "false" || isEmpty(login)) {
      setIsLogin(false);
    }
  }, []);

  return (
    <Grid padding={isLogin ? 2 : 0}>
      <BrowserRouter basename="/karedb">
        <Grid container>
          {isLogin && <MenuBar setIsLogin={setIsLogin} />}
          <Routes>
            <Route path="/" element={<LoginPage setIsLogin={setIsLogin} />} />
            <Route path="agreements" element={<Agreements />} />
            <Route path="treatments" element={<Treatments />} />
            <Route path="cities" element={<Cities />} />
            <Route path="insurance" element={<InsuranceHome />} />
            <Route path="doctors" element={<Doctors />} />
            <Route path="dashBoard" element={<DashBoard />} />
            <Route path="hospital" element={<Hospital />} />
            <Route path="mySpace" element={<MySpace />} />
            <Route path="details" element={<Details />} />
            <Route path="approvalsPending" element={<ApprovalsPending />} />
            <Route
              path="hospitalAddPage"
              element={<HospitalAddPage key="add" />}
            />
            <Route path="addhospital" element={<HospitalAddPage />} />
            <Route path="doctorAddPage" element={<AddNewDoctor />} />
            <Route path="adddoctor" element={<AddNewDoctor key="add" />} />
            {/* <Route path="*" element={<PageNotFound />} /> */}
          </Routes>
        </Grid>
      </BrowserRouter>
    </Grid>
    // <LoginPage />
  );
}

export default App;
